import React from "react";
import { getReviewOutcomeLabels, useTranslation } from "../../../i18n";
import { outcomeBadgeClass } from "../../utils/deletionCaseOutcomes";

const DeletionCaseOutcomeBadge = ({ outcome, className = "" }) => {
  const { t } = useTranslation();
  const labels = getReviewOutcomeLabels(t);

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${outcomeBadgeClass(outcome)} ${className}`}
    >
      {labels[outcome] || outcome}
    </span>
  );
};

export default DeletionCaseOutcomeBadge;
